module.exports = __webpack_public_path__ + "static/images/cover_C14.9bf3619.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C14.png
// module id = 57CH
// module chunks = 8